import React from 'react'
import {Col, Row, Label,Input} from "reactstrap";
import {Spinner } from "react-bootstrap"
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Typography,
  Button,
  TextField,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import { useSendPaymentDocMutation,useUploadPaymentProofMutation } from './ProcurementApiSlice';
import "react-awesome-lightbox/build/style.css";
import Autocomplete from "@mui/material/Autocomplete";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { NoBackpackSharp } from '@mui/icons-material';

const steps = ["Payment Initiated *", "Payment Proof *"];

const PaymentDocs = ({FullList,user_id,refetch,handleClosePayment}) => {
  const [selectedFile, setSelectedFile] = useState("")
  const[selectedFileProof,setSelectedFileProof]=useState("")
  // const [paymentData, setPaymentData] = useState({amount: parseFloat(FullList?.payments?.total_paid_by_buyer || 0) + 
  //   parseFloat(FullList?.payments?.total_unpaid_by_buyer || 0),remark:"",quantity:FullList.payments?.total_quantity_for_buyer})
  const [paymentData, setPaymentData] = useState({amount: parseFloat(FullList?.final_price) *
    parseFloat(FullList?.final_quantity),remark:"",quantity:FullList.payments?.total_quantity_for_buyer})
    
  const[updatedListBuyer,setupdatedListBuyer]=useState([])

 const [payment,] = useSendPaymentDocMutation();
  const [paymentProof] = useUploadPaymentProofMutation();
  const [paymentDataProof,setPaymentDataProof] = useState({});

   const[spinner,setSpinner]=useState(false)
   const[spinnerProof,setSpinnerProof]=useState(false)
   const PaymnetMethods = [
    { title: "CHEQUE", year: 1991 },
    { title: "NEFT", year: 1990 },
    { title: "NET BANKING", year: 1993 },
    { title: "RTGS", year: 1994 },
    { title: "C/D", year: "C/D" },
  ];
const[updatedList,setUpdatedList]=useState([])

  // useEffect(()=>{
  //   const updatedList = FullList?.all_media?.filter(item => item.entity_type === "Seller" && item.file_extension==="pdf");
  //   setUpdatedList(updatedList)
  //   const updatedListBuyer = FullList?.all_media?.filter(item => item.entity_type === "Buyer" && item.file_extension==="pdf");
  //   setupdatedListBuyer(updatedListBuyer)
  // },[FullList])
  const [activeStep, setActiveStep] = useState(FullList?.document_status?.payment_sheet_buyer && (FullList.payments.buyer_status==="Payment Initiated"|| FullList.payments.buyer_status==="Payment In Progress") ? 1 : 0
);
  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      console.log("entering for close")
      handleClosePayment()
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
const handleDocuments = (e) =>{
  e.preventDefault()
        setSpinner(true)
        const formData = new FormData()
        formData.append("entity_type", "Buyer") 
        formData.append("amount", paymentData.amount) 
        formData.append("reduction_criteria", paymentData.reduction_criteria?paymentData.reduction_criteria:"0") 
        formData.append("remark", paymentData.remark) 
        formData.append("buyer", user_id) 
        formData.append("file", selectedFile) 
        formData.append("procurement", FullList.ProcCode) 
        payment(formData)
        .unwrap()
        .then((data) => {
          toast.success("Document Uploaded Successfully !!");
          refetch()
          setSelectedFile("")
          setActiveStep(1)
          setSpinner(false)
        })
        .catch((error) => {
          toast.error("Something went wrong !!");
          setSpinner(false)
          return;
        });
}
const handleDocumentsPaymentProof = (e) =>{
  e.preventDefault()
  setSpinnerProof(true)
    const formData = new FormData()
    formData.append("entity_type", "Buyer") 
    formData.append("user_id", user_id) 
    formData.append("file",paymentDataProof.payment_method==="C/D"?"": selectedFileProof) 
    formData.append("category", "Procurement") 
    formData.append("pattern", 3) 
    formData.append("ProcCode", FullList.ProcCode) 
    formData.append("payment_method", paymentDataProof.payment_method==="C/D"?"Discount":paymentDataProof.payment_method) 
    formData.append("transaction_id", paymentDataProof.payment_method==="C/D"?"":paymentDataProof.transaction_id) 
    formData.append("amount", paymentDataProof.amount) 
    paymentProof(formData)
    .unwrap()
    .then((data) => {
      toast.success("Document Uploaded Successfully !!");
      setSelectedFile("")
      refetch()
      handleClosePayment()
      setSpinnerProof(false)
    })
   
    .catch((data) => {
      if (data.data.status == 400) {
          toast.error(`${data.data.message}`);
          setSpinnerProof(false);
          return;
        }
    });
}
const handleChange = (name) => (e, value) => {
    setPaymentData({
        ...paymentData,
        [e.target.name]: e.target.value,
      });
}
const handleChangePaymentProof = (name) => (e, value) => {
  if (name === "payment_method") {
    setPaymentDataProof({
      ...paymentDataProof,
      [name]: value,
    });
  } 
 else{
    setPaymentDataProof({
        ...paymentDataProof,
        [e.target.name]: e.target.value,
      });
    }
}
const handleChangeFile=(event)=>{
    setSelectedFile(event.target.files[0])
}
const handleChangeProof=(event)=>{
    setSelectedFileProof(event.target.files[0])
}
  const handleViewPdf = (url) => {
    window.open(url, '_blank');
  };
  const handleNextDisabled=()=>{
   if(activeStep === steps.length - 1)
    return true
     if(!FullList?.document_state?.payment_sheet)
      return true
  }
  const handleViewPaymentSheet = () => {
    // Find the document where entity_type is "Buyer" and pattern is "Payment Sheet"
    const paymentSheet = FullList?.all_media?.find(doc => doc.entity_type === "Buyer" && doc.pattern === "Payment Sheet");
    
    if (paymentSheet) {
        // Open the PDF file in a new tab
        window.open(paymentSheet.file, '_blank');
    } else {
        alert('Payment Sheet for Buyer not found.');
    }
};
  return (
    <>
      <div>
            <Container maxWidth="sm" sx={{ mt: 8 }}>
              <Stepper activeStep={activeStep}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <Grid container direction="column" alignItems="center" spacing={2}>
                <Grid item xs={12}>
                  {activeStep === 0 && (
                <form onSubmit={(e)=>handleDocuments(e)}>
                    <div className="mt-2 mx-2">
            {/* <Typography variant="h7" className='mt-5 textColorHeading text-underline'>
                Upload Payment Details (Excl GST)&nbsp;
            </Typography> */}
            <Row className="align-items-center mt-3">
            {/* <Col className="col-lg-6 MuiTextArea">
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Amount"
                    type="number"
                    name="amount"
                    required
                    multiline
                    maxRows={2}
                    disabled={FullList?.document_status?.payment_sheet_buyer}
                    onChange={handleChange("amount")}
                    style={{ width: "100%" }}
                    value={paymentData.amount}
                    InputLabelProps={{ shrink: true }} 
                    className="mx-1"
                  />
                  </Col>
                  <Col className="col-lg-6 MuiTextArea">
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Reduction Criteria"
                    name="reduction_criteria"
                    type="text"
                    multiline
                    maxRows={2}
                    disabled={FullList?.document_status?.payment_sheet_buyer}

                    onChange={handleChange("reduction_criteria")}
                    style={{ width: "100%" }}
                    value={paymentData.reduction_criteria}
                    InputLabelProps={{ shrink: true }} 
                    className="mx-1"
                  />
                  </Col> */}


<div className="payment-summary-container p-4 border rounded shadow-sm mt-2">
  {/* Commodity and Quantity */}
  <div className="d-flex justify-content-between mb-3">
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Commodity :</strong>{" "}
      <span className="text-dark">{FullList?.crop_name || "-"}</span>
    </div>
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Trade Value (Exc GST) : </strong>{" "}
      <span className="text-dark">
      ₹ {parseFloat(FullList?.final_price) *
      parseFloat(FullList?.final_quantity)}
      </span>
    </div>
   
   
  </div>
  <div className="d-flex justify-content-between mb-3">
  <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Quantity : </strong>{" "}
      <span className="text-dark">
        {FullList?.final_quantity || 0} {FullList?.unit_of_measure || "-"}
      </span>
    </div>
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Price/Unit : </strong>{" "}
      <span className="text-dark">
      ₹ {parseFloat(FullList?.final_price)}
      </span>
    </div>
   
   
  </div>
 

  {/* GST and Commission */}
  <div className="d-flex justify-content-between mb-3">
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>GST : </strong>{" "}
      <span className="text-dark">{FullList?.payments?.total_gst_for_buyer || 0}</span>
    </div>
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Commission : </strong>{" "}
      <span className="text-dark">{FullList?.payments?.total_commission || 0}</span>
    </div>
  </div>

  {/* Total Amount */}
  <div className="d-flex justify-content-between mb-3">
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Total Amount : </strong>{" "}
      <span className="text-dark">
      ₹ {(
          parseFloat(FullList?.payments?.total_paid_by_buyer || 0) +
          parseFloat(FullList?.payments?.total_unpaid_by_buyer || 0)
        ).toFixed(2)}
      </span>
    </div>
  </div>

  {/* Paid and Unpaid Amount */}
  <div className="d-flex justify-content-between mb-3">
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Paid Amount : </strong>{" "}
      <span className="text-dark">₹ {FullList?.payments?.total_paid_by_buyer || 0}</span>
    </div>
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Unpaid Amount : </strong>{" "}
      <span className="text-dark"> ₹ {FullList?.payments?.total_unpaid_by_buyer || 0}</span>
    </div>
  </div>
</div>

                  <Col lg="12" className="mb-2 mt-2">
                    <Label>Upload (Pdf format only *)</Label>
                    <Input
                        style={{ fontSize: "15px" }}
                        type="file"
                        accept=".pdf"
                        required
                        onChange={(e) => handleChangeFile(e)}
                    />
                </Col>
               
                  <Col className="col-lg-12 mt-3">
                   <TextField
                placeholder="Type the message"
                multiline
                label="Remarks"
                onChange={handleChange("remark")}
                disabled={FullList?.document_status?.payment_sheet_buyer}

                rows={2}
                maxRows={3}
                className='mt-1'
                style={{width:"100%"}}
                InputLabelProps={{ shrink: true }} // Keep the label always shrunk
               />
                  </Col>
                  <div className='text-center mt-2'>
                    {FullList?.document_status?.payment_sheet_buyer?
                            <Button size="sm" varient="contained" >
                              Submitted
                            </Button>
                             :<Button size="sm" className="bgSuccessClass" type="submit" >
                              Submit {spinner&&<Spinner size="sm"/>}
                            </Button>
                    }
                </div>
            </Row>
        </div>
                    </form>

                  )}
                  {activeStep === 1 && (
                    <>
                 <div className="payment-summary-container p-4 border rounded shadow-sm mt-2">
  {/* Commodity and Quantity */}
  <div className="d-flex justify-content-between mb-3">
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Commodity :</strong>{" "}
      <span className="text-dark">{FullList?.crop_name || "-"}</span>
    </div>
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Trade Value (Exc GST) : </strong>{" "}
      <span className="text-dark">
      ₹ {parseFloat(FullList?.final_price) *
      parseFloat(FullList?.final_quantity)}
      </span>
    </div>
   
   
  </div>
  <div className="d-flex justify-content-between mb-3">
  <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Quantity : </strong>{" "}
      <span className="text-dark">
        {FullList?.final_quantity || 0} {FullList?.unit_of_measure || "-"}
      </span>
    </div>
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Price/Unit : </strong>{" "}
      <span className="text-dark">
      ₹ {parseFloat(FullList?.final_price)}
      </span>
    </div>
   
   
  </div>
 

  {/* GST and Commission */}
  <div className="d-flex justify-content-between mb-3">
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>GST : </strong>{" "}
      <span className="text-dark">{FullList?.payments?.total_gst_for_buyer || 0}</span>
    </div>
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Commission : </strong>{" "}
      <span className="text-dark">{FullList?.payments?.total_commission || 0}</span>
    </div>
  </div>

  {/* Total Amount */}
  <div className="d-flex justify-content-between mb-3">
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Total Amount : </strong>{" "}
      <span className="text-dark">
      ₹ {(
          parseFloat(FullList?.payments?.total_paid_by_buyer || 0) +
          parseFloat(FullList?.payments?.total_unpaid_by_buyer || 0)
        ).toFixed(2)}
      </span>
    </div>
  </div>

  {/* Paid and Unpaid Amount */}
  <div className="d-flex justify-content-between mb-3">
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Paid Amount : </strong>{" "}
      <span className="text-dark">₹ {FullList?.payments?.total_paid_by_buyer || 0}</span>
    </div>
    <div className="text-muted" style={{ fontSize: "13px" }}>
      <strong>Unpaid Amount : </strong>{" "}
      <span className="text-dark">₹ {FullList?.payments?.total_unpaid_by_buyer || 0}</span>
    </div>
  </div>
</div>
                <form onSubmit={(e) => handleDocumentsPaymentProof(e)}>
                    <div className=" mt-4 mx-2">
                        {/* <Typography variant="h7" className='mt-5 textColorHeading mx-2'>Upload Payment Proof&nbsp;</Typography> */}
                        <Row className="align-items-center mt-3">
                        <Col className="col-lg-6 MuiTextArea">
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Amount"
                    name="amount"
                    type="number"
                    required
                    multiline
                    maxRows={2}
                    onChange={handleChangePaymentProof("amount")}
                    style={{ width: "100%" }}
                    InputLabelProps={{ shrink: true }} // Keep the label always shrunk
                    className="mx-1"
                  />
                  </Col>
                        <Col className="col-lg-6 MuiTextArea">
                
                     <Autocomplete
                            freeSolo
                            id="payment_method"
                            name="payment_method"
                            required
                            disableClearable
                            // value={addStockData.unit_measurement}
                            onChange={handleChangePaymentProof("payment_method")}
                            options={PaymnetMethods?.map((option) => option.title)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Payment Method"
                                InputLabelProps={{ shrink: true }}
                                required
                                InputProps={{
                                  ...params.InputProps,
                                  type: "search",
                                  endAdornment: (
                                    <>
                                      {params.InputProps.endAdornment}
                                      <ArrowDropDownIcon />
                                    </>
                                  ),
                                }}
                              />
                            )}
                          />
                  </Col>
                  {paymentDataProof?.payment_method==="C/D"?"":
                  <>
                  <Col className="col-lg-12 MuiTextArea mt-3">
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Transaction Id"
                    name="transaction_id"
                    required
                    multiline
                    maxRows={2}
                    onChange={handleChangePaymentProof("transaction_id")}
                    style={{ width: "100%" }}
                    InputLabelProps={{ shrink: true }} // Keep the label always shrunk
                    className="mx-1"
                  />
                  </Col>
     
      <Col lg="12" className="mb-2 mt-2">
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <Label>Upload (Pdf format only *)</Label>
    <span style={{ fontSize: '14px', color: 'steelblue', cursor: 'pointer' }} onClick={handleViewPaymentSheet}>
      View Payment Sheet
    </span>
  </div>
  <Input
    style={{ fontSize: '15px' }}
    type="file"
    accept=".pdf"
    required
    onChange={(e)=>handleChangeProof(e)}
    />
</Col>
</>}
      <div className='text-center mt-2'>

                            {FullList?.document_status?.payment_proof_buyer?
                            <Button size="sm" varient="contained" >
                              Submitted
                            </Button>
                              :
                            <Button size="sm" className="bgSuccessClass" type="submit">
                              Submit &nbsp;  {spinnerProof&&<Spinner size="sm"/>}
                            </Button>
                            }
                            </div>
      </Row>
                      </div>
                    </form>
                    </>
                  )}
                </Grid>
                <Grid container spacing={3} alignItems="center" className='mt-2'>
      {/* Grid for Uploaded Documents */}
      {/* <Grid item xs={12} sm={4}>
        {updatedList?.length > 0 && (
          <div className='p-3'>
            <h5 className='text-gray'> Seller Uploaded Documents </h5>
            {updatedList?.map((doc) => (
              <li key={doc.id} className="document-item">
                {doc.file_extension === 'pdf' && (
                  <>
                    <span>{doc.pattern} :</span>
                    <span
                      color="primary"
                      className='text-warning mx-2 cursor-pointer'
                      onClick={() => handleViewPdf(doc.file)}
                    >
                      <PictureAsPdfIcon />
                    </span>
                  </>
                )}
              </li>
            ))}
          </div>
        )}
      </Grid>
      <Grid item xs={12} sm={5}>
        {updatedListBuyer.length > 0 && (
          <div className='p-2'>
            <h5 className='text-gray'> Self Uploaded Documents</h5>
            {updatedListBuyer.map((doc) => (
              <li key={doc.id} className="document-item">
                {doc.file_extension === 'pdf' && (
                  <>
                    <span>{doc.pattern} :</span>
                    <span
                      color="primary"
                      className='text-warning mx-2 cursor-pointer'
                      onClick={() => handleViewPdf(doc.file)}
                    >
                      <PictureAsPdfIcon />
                    </span>
                  </>
                )}
              </li>
            ))}
          </div>
        )}
      </Grid> */}

<Grid item xs={12} container justifyContent="flex-end">
  {activeStep > 0 && (
    <Button
      variant="contained"
      color="primary"
      onClick={handleBack}
      sx={{ marginRight: 2 }}
      className="mb-3"
      size="small"
    >
      Back
    </Button>
  )}
  <Button
    variant="contained"
    color="secondary"
    onClick={handleNext}
    className="mb-3"
  >
    {activeStep === steps.length - 1 ? "Close" : "Next"}
  </Button>
</Grid>

    </Grid>
              </Grid>
            </Container>
      </div>
    </>
  )
}

export default PaymentDocs
